import React, { useEffect, useState } from 'react';
import { Link, useMatch } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import classnames from 'classnames';
import { logout } from '../../store/actions/auth';
import {
	Collapse,
	NavbarBrand,
	Navbar,
	Nav,
	NavItem,
	Button,
	Container,
} from 'reactstrap';
import './BusinessNavbar.css';

function NavbarBusiness() {
	const dispatch = useDispatch();
	const currentUser = useSelector((state) => state.currentUser.user);

	const [publicPageLink, setPublicPageLink] = useState('/');
	const [navbarColor] = useState('');
	const [bodyClick, setBodyClick] = useState(false);
	const [collapseOpen, setCollapseOpen] = useState(false);

	const pageSignup = useMatch('/signup');
	const pageSignin = useMatch('/signin');
	const pagePricing = useMatch('/pricing');
	// const pageBuildingSearch = useMatch('/building-search-page');

	useEffect(() => {
		const navbar = document.getElementById('navbar-business');
		if (!navbar) return;
	}, []);

	useEffect(() => {
		setPublicPageLink(
			currentUser?.id ? `/business-page/${currentUser.id}` : '/',
		);
	}, [currentUser]);

	const closeMobileMenu = () => {
		document.documentElement.classList.remove('nav-open');
		setBodyClick(false);
		setCollapseOpen(false);
	};

	const openMobileMenu = () => {
		document.documentElement.classList.add('nav-open');
		setBodyClick(true);
		setCollapseOpen(true);
	};

	return (
		<>
			{bodyClick ? <div id='bodyClick' onClick={closeMobileMenu} /> : null}

			<Navbar
				className={classnames('fixed-top business-navbar', navbarColor)}
				id='navbar-business'
				expand='lg'>
				<Container fluid className='business-navbar__container'>
					<NavbarBrand
						tag={Link}
						to={currentUser?.id ? '/business-page' : '/'}
						className='business-navbar__brand'>
						{currentUser?.id ? currentUser.businessName : 'Weciny'}
					</NavbarBrand>

					<button
						className='navbar-toggler business-navbar__toggler'
						type='button'
						onClick={collapseOpen ? closeMobileMenu : openMobileMenu}>
						<span className='navbar-toggler-bar bar1'></span>
						<span className='navbar-toggler-bar bar2'></span>
						<span className='navbar-toggler-bar bar3'></span>
					</button>

					<Collapse
						navbar
						isOpen={collapseOpen}
						className={`business-navbar__collapse ${
							collapseOpen ? 'business-navbar__collapse--open' : ''
						}`}>
						<Nav className='business-navbar__actions' navbar>
							{currentUser?.id ? (
								<>
									{/* {pageBuildingSearch === null && (
										<NavItem className='business-navbar__nav-item'>
											<Button
												className='business-navbar__btn business-navbar__btn--secondary'
												href='/building-search-page'
												type='button'>
												Market with locals
											</Button>
										</NavItem>
									)} */}

									<NavItem className='business-navbar__nav-item'>
										<Button
											className='business-navbar__btn business-navbar__btn--ghost'
											target='_blank'
											href={publicPageLink}
											type='button'>
											Public website
										</Button>
									</NavItem>

									<NavItem className='business-navbar__nav-item'>
										<Button
											className='business-navbar__btn business-navbar__btn--danger'
											onClick={() => dispatch(logout())}
											type='button'>
											Sign out
										</Button>
									</NavItem>
								</>
							) : (
								<>
									{pageSignup === null && (
										<NavItem className='business-navbar__nav-item'>
											<Button
												className='business-navbar__btn business-navbar__btn--primary'
												href='/signup'>
												Create your online store
											</Button>
										</NavItem>
									)}

									{pagePricing === null && (
										<NavItem className='business-navbar__nav-item'>
											<Button
												className='business-navbar__btn business-navbar__btn--ghost'
												href='/pricing'
												type='button'>
												Pricing
											</Button>
										</NavItem>
									)}

									{pageSignin === null && (
										<NavItem className='business-navbar__nav-item'>
											<Button
												className='business-navbar__btn business-navbar__btn--ghost'
												href='/signin'
												type='button'>
												Sign in
											</Button>
										</NavItem>
									)}
								</>
							)}
						</Nav>
					</Collapse>
				</Container>
			</Navbar>
		</>
	);
}

export default NavbarBusiness;
